module.exports = __webpack_public_path__ + "static/media/forgot_password.56cff9bf.svg";